import { Field } from 'react-final-form';
import { RenderIf } from 'react-rainbow-components';
import { isEmpty } from '@rainbow-modules/validation';
import identity from 'helpers/identity';
import {
    FieldsContainer,
    StyledInput,
    Message,
    StyledTextarea,
    Row,
} from './styled';

interface Params {
    message?: string;
    disabledFields?: string[]
}

const validateNotEmpty = (value: unknown) => {
    if (isEmpty(value)) return 'This field is required';
    return undefined;
};

const Fields = ({
    message = '',
    disabledFields = [],
}: Params) => (
    <>
        <RenderIf isTrue={message}>
            <Message>{message}</Message>
        </RenderIf>
        <FieldsContainer>
            <Row>
                <Field
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    component={StyledInput}
                    name="name"
                    label="Name"
                    labelAlignment="left"
                    placeholder="Enter a name for the pipeline"
                    borderRadius="semi-square"
                    autoComplete="off"
                    disabled={disabledFields.includes('name')}
                    required
                    validate={validateNotEmpty}
                />
            </Row>
            <Row>
                <Field
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    component={StyledTextarea}
                    name="description"
                    label="Description"
                    labelAlignment="left"
                    placeholder="Enter a description for the pipeline"
                    borderRadius="semi-square"
                    rows={4}
                    parse={identity}
                />
            </Row>
        </FieldsContainer>
    </>
);

export default Fields;
